/**
 * Cost codes (migration 0016). Every cost is booked to one: an employee's day,
 * a plant's fuel, a misc expense. Employees and plants carry a usual code that
 * starts the day; the office changes it on the day when the work was for
 * something else.
 *
 * The list rides on /reference with the plants and categories, removed codes
 * included so a day entered under one can still name it. The pickers offer
 * the active ones, plus whatever the row already carries.
 */

import { request } from './api';

export interface CostCode {
  id: string;
  code: string;
  name: string;
  is_active: number;
}

/** What a picker offers: the active codes, and the row's own even if removed. */
export function codeOptions(codes: CostCode[], current: string | null | undefined): CostCode[] {
  return codes.filter((code) => code.is_active || code.id === current);
}

/** "CC-01" — or "" for none. */
export function codeOf(codes: CostCode[], id: string | null | undefined): string {
  if (!id) return '';
  return codes.find((code) => code.id === id)?.code ?? '';
}

/** "CC-01 — Drilling and blasting", as the drop-downs say it. */
export function codeLabel(code: CostCode): string {
  return `${code.code} — ${code.name}`;
}

/** The Settings card: the list with how many employees and plants use each. */
export interface CostCodeRow {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
  sortOrder: number;
  rowVersion: number;
  employees: number;
  plants: number;
}

export const costCodeApi = {
  list: () => request<{ costCodes: CostCodeRow[] }>('/cost-codes'),
  create: (body: { code: string; name: string }) =>
    request<CostCodeRow>('/cost-codes', { method: 'POST', body }),
  update: (id: string, body: { code?: string; name?: string; rowVersion?: number }) =>
    request<CostCodeRow>(`/cost-codes/${id}`, { method: 'PATCH', body }),
  remove: (id: string) => request<void>(`/cost-codes/${id}`, { method: 'DELETE' }),
};
